import { render, staticRenderFns } from "./ClassroomManage.vue?vue&type=template&id=af56622a&scoped=true"
import script from "./ClassroomManage.vue?vue&type=script&lang=js"
export * from "./ClassroomManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af56622a",
  null
  
)

export default component.exports